import React from 'react';
import ImageUploadBox from '@/components/common/ImageUploadBox';

export interface EpisodeDetailsFormProps {
  data: Api.Application.Step3Request;
  onChange: (data: Api.Application.Step3Request) => void;
}

export default function EpisodeDetailsForm({ data, onChange }: EpisodeDetailsFormProps) {
  const episodes = data?.episodes || [{ episode_no: 1, episode_title: '', upload_asset_id: '' }];

  const updateEpisode = (idx: number, field: keyof Api.Application.EpisodeRequest, val: any) => {
    const next = [...episodes];
    next[idx] = { ...next[idx], [field]: val };
    onChange({ episodes: next });
  };

  const addEpisode = () => {
    const nextNo = episodes.length + 1;
    onChange({
      episodes: [...episodes, { episode_no: nextNo, episode_title: '', upload_asset_id: '' }],
    });
  };

  const removeEpisode = (idx: number) => {
    if (episodes.length <= 1) return;
    const filtered = episodes.filter((_, i) => i !== idx).map((item, i) => ({
      ...item,
      episode_no: i + 1,
    }));
    onChange({ episodes: filtered });
  };

  return (
    <div className="space-y-5">
      <p className="text-sm text-foreground-600 mb-3">为每集填写标题并上传正片源文件，方便平台分发。</p>
      {episodes.map((ep, idx) => (
        <div key={idx} className="p-5 rounded-xl border border-gray-200/80 bg-white space-y-4 shadow-2xs">
          <div className="flex items-center justify-between pb-2 border-b border-gray-100">
            <span className="text-sm font-bold text-primary-700 bg-primary-50 border border-primary-100 px-3.5 py-1.5 rounded-full">
              第 {ep.episode_no || idx + 1} 集
            </span>
            {episodes.length > 1 && (
              <button
                onClick={() => removeEpisode(idx)}
                className="text-xs md:text-sm text-foreground-400 hover:text-red-500 font-medium cursor-pointer transition-colors"
                type="button"
              >
                <i className="ri-delete-bin-line mr-1"></i> 删除
              </button>
            )}
          </div>

          <div>
            <label className="block text-sm font-bold text-foreground-800 mb-2">
              剧集标题 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={ep.episode_title || ''}
              onChange={(e) => updateEpisode(idx, 'episode_title', e.target.value)}
              placeholder={`第 ${ep.episode_no || idx + 1} 集标题`}
              className="w-full px-4 py-3 rounded-lg bg-white border border-gray-200/80 text-base text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all"
            />
          </div>

          <div>
            <label className="block text-sm font-bold text-foreground-800 mb-2">
              单集视频 <span className="text-red-500">*</span>
            </label>
            <ImageUploadBox
              value={(ep as any).access_url || ep.upload_asset_id}
              onChange={(assetId) => updateEpisode(idx, 'upload_asset_id', assetId)}
              scene="APPLICATION"
              policy="uploader-only"
              accept="video/*,.mp4,.mov"
              isVideo={true}
              placeholder={`点击或拖拽上传第 ${ep.episode_no || idx + 1} 集视频`}
              subPlaceholder="支持 MP4, MOV 视频文件"
            />
          </div>
        </div>
      ))}
      <button
        onClick={addEpisode}
        className="w-full py-3.5 rounded-xl border-2 border-dashed border-gray-300 text-base font-semibold text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer flex items-center justify-center gap-2"
        type="button"
      >
        <i className="ri-add-line text-lg"></i>添加新剧集
      </button>
    </div>
  );
}